import React, { useState, useEffect } from "react";
import { Modal, Button, Container, Row, Col } from "react-bootstrap";
import AttendanceServices from "../../../services/AttendanceServices";
import RequestServies from "../../../services/RequestServies";
import Swal from "sweetalert2";
import FilePreviewModal from "../Accounts/FilePreviewModal";

const ReviewAttendanceModal = ({
    show,
    handleClose,
    attendance,
    setRun
}) => {

    const [remark, setRemark] = useState("");
    const [editMode, setEditMode] = useState(false);
    const [startKM, setStartKM] = useState(0);
    const [endKM, setEndKM] = useState(0);
    const [showPreview, setShowPreview] = useState(false);
    const [previewFile, setPreviewFile] = useState(null);
    const [dieselInReading, setDieselInReading] = useState(0);
    const [dieselOutReading, setDieselOutReading] = useState(0);
    const [machineHistory, setMachineHistory] = useState([]);
    const [historyLoading, setHistoryLoading] = useState(false);

    console.log("attendance", attendance);
    console.log("vehicleId", attendance?.vehicleId);
    console.log("vehicleStoreId", attendance?.vehicleStoreId);

    useEffect(() => {

        if (attendance) {

            setStartKM(attendance?.startKM || 0);
            setEndKM(attendance?.endKM || 0);

            setDieselInReading(
                attendance?.dieselInReading || 0
            );

            setDieselOutReading(
                attendance?.dieselOutReading || 0
            );

            setEditMode(false);
        }

    }, [attendance]);

    const handleUpdate = async () => {

        try {

            await AttendanceServices.updateAttendance(
                attendance._id,
                {
                    startKM,
                    endKM,
                    dieselInReading,
                    dieselOutReading
                }
            );

            Swal.fire(
                "Success",
                "Attendance updated successfully",
                "success"
            );

            setRun(prev => prev + 1);

            setEditMode(false);

        } catch (err) {

            Swal.fire(
                "Error",
                err?.response?.data?.message ||
                "Something went wrong",
                "error"
            );
        }
    };

    const handleApprove = async () => {

        const result = await Swal.fire({
            title: "Approve Attendance?",
            text: "Are you sure you want to approve this attendance?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Yes, Approve",
            cancelButtonText: "Cancel"
        });

        if (!result.isConfirmed) return;

        try {

            await AttendanceServices.approveAttendance(
                attendance._id
            );

            Swal.fire(
                "Approved",
                "Attendance approved successfully",
                "success"
            );

            setRun(prev => prev + 1);

            handleClose();

        } catch (err) {

            Swal.fire(
                "Error",
                err?.response?.data?.message ||
                "Something went wrong",
                "error"
            );

        }
    };

    const handleReject = async () => {

        const { value: remark } = await Swal.fire({
            title: "Reject Attendance",
            input: "textarea",
            inputLabel: "Rejection Remark",
            inputPlaceholder: "Enter rejection remark...",
            inputValidator: (value) => {
                if (!value?.trim()) {
                    return "Rejection remark is required";
                }
            },
            showCancelButton: true,
            confirmButtonText: "Reject",
            confirmButtonColor: "#d33"
        });

        if (!remark) return;

        try {

            await AttendanceServices.rejectAttendance(
                attendance._id,
                remark
            );

            Swal.fire(
                "Rejected",
                "Attendance rejected successfully",
                "success"
            );

            setRun(prev => prev + 1);

            handleClose();

        } catch (err) {

            Swal.fire(
                "Error",
                err?.response?.data?.message ||
                "Something went wrong",
                "error"
            );

        }
    };



    const getImageUrl = (fileName) => {

        if (!fileName) return "";

        const baseUrl =
            window.location.hostname === "localhost"
                ? "http://localhost:3001"
                : "https://indigoinfra.in";

        return `${baseUrl}/img/attendance/${fileName}`;
    };

    useEffect(() => {

        const fetchMachineHistory = async () => {

            if (!attendance?.vehicleId ||
                !attendance?.vehicleStoreId) {
                return;
            }

            try {

                setHistoryLoading(true);

                const response =
                    await RequestServies.machineDieselHistory({
                        store: attendance.vehicleStoreId,
                        machine: attendance.vehicleId
                    });

                setMachineHistory(
                    response?.data || []
                );

            } catch (error) {

                console.log(error);

                Swal.fire(
                    "Error",
                    "Failed to load machine diesel history",
                    "error"
                );

            } finally {

                setHistoryLoading(false);

            }

        };

        if (show) {
            fetchMachineHistory();
        }

    }, [
        show,
        attendance
    ]);

    if (!attendance) return null;

    return (
        <>
            <Modal
                show={show}
                onHide={handleClose}
                size="xl"
                centered
                enforceFocus={false}
            >
                <Modal.Header>
                    <Modal.Title>
                        Attendance Review
                    </Modal.Title>

                    <Button
                        variant=""
                        className="btn-close"
                        onClick={handleClose}
                    />
                </Modal.Header>

                <Modal.Body>

                    <Container fluid>

                        <Row>

                            <Col md="4">
                                <label>Part No</label>
                                <input
                                    className="form-control"
                                    value={
                                        attendance?.vehicle?.asset?.masterItem?.partNo || ""
                                    }
                                    readOnly
                                />
                            </Col>

                            <Col md="8">
                                <label>Description</label>
                                <input
                                    className="form-control"
                                    value={
                                        attendance?.vehicle?.asset?.masterItem?.description || ""
                                    }
                                    readOnly
                                />
                            </Col>

                            <Col md="4" className="mt-2">
                                <label>Equipment No</label>
                                <input
                                    className="form-control"
                                    value={
                                        attendance?.vehicle?.asset?.equipmentNo || ""
                                    }
                                    readOnly
                                />
                            </Col>

                            <Col md="4" className="mt-2">
                                <label>Driver</label>
                                <input
                                    className="form-control"
                                    value={attendance?.driver?.name || ""}
                                    readOnly
                                />
                            </Col>

                            <Col md="4" className="mt-2">
                                <label>Store</label>
                                <input
                                    className="form-control"
                                    value={attendance?.store?.name || ""}
                                    readOnly
                                />
                            </Col>

                        </Row>

                        <hr />

                        <Row>

                            <Col md="3">
                                <label>Start KM</label>

                                {editMode ? (

                                    <input
                                        type="number"
                                        className="form-control"
                                        value={startKM}
                                        onChange={(e) =>
                                            setStartKM(e.target.value)
                                        }
                                    />

                                ) : (

                                    <div className="form-control d-flex justify-content-between align-items-center">

                                        <span>{startKM}</span>

                                        <div>

                                            {attendance?.meterPhotos?.start && (

                                                <i
                                                    className="fas fa-image text-primary me-2"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => {

                                                        setPreviewFile({
                                                            url: getImageUrl(
                                                                attendance?.meterPhotos?.start
                                                            )
                                                        });

                                                        setShowPreview(true);

                                                    }}
                                                />

                                            )}

                                            <i
                                                className="fas fa-edit text-warning"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => setEditMode(true)}
                                            />

                                        </div>

                                    </div>

                                )}
                            </Col>

                            <Col md="3">
                                <label>End KM</label>

                                {editMode ? (

                                    <input
                                        type="number"
                                        className="form-control"
                                        value={endKM}
                                        onChange={(e) =>
                                            setEndKM(e.target.value)
                                        }
                                    />

                                ) : (

                                    <div className="form-control d-flex justify-content-between align-items-center">

                                        <span>{endKM}</span>

                                        <div>

                                            {attendance?.meterPhotos?.end && (

                                                <i
                                                    className="fas fa-image text-primary me-2"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => {

                                                        setPreviewFile({
                                                            url: getImageUrl(
                                                                attendance?.meterPhotos?.end
                                                            )
                                                        });

                                                        setShowPreview(true);

                                                    }}
                                                />

                                            )}

                                            <i
                                                className="fas fa-edit text-warning"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => setEditMode(true)}
                                            />

                                        </div>

                                    </div>

                                )}
                            </Col>

                            <Col md="3">
                                <label>Diesel In</label>

                                {editMode ? (

                                    <input
                                        type="number"
                                        className="form-control"
                                        value={dieselInReading}
                                        onChange={(e) =>
                                            setDieselInReading(e.target.value)
                                        }
                                    />

                                ) : (

                                    <div className="form-control d-flex justify-content-between align-items-center">

                                        <span>{dieselInReading}</span>

                                        <i
                                            className="fas fa-edit text-warning"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => setEditMode(true)}
                                        />

                                    </div>

                                )}
                            </Col>

                            <Col md="3">
                                <label>Diesel Out</label>

                                {editMode ? (

                                    <input
                                        type="number"
                                        className="form-control"
                                        value={dieselOutReading}
                                        onChange={(e) =>
                                            setDieselOutReading(e.target.value)
                                        }
                                    />

                                ) : (

                                    <div className="form-control d-flex justify-content-between align-items-center">

                                        <span>{dieselOutReading}</span>

                                        <i
                                            className="fas fa-edit text-warning"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => setEditMode(true)}
                                        />

                                    </div>

                                )}
                            </Col>

                        </Row>

                        <hr />

                        <h5>Diesel Fill-Up History</h5>

                        <table className="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>MIV No</th>
                                    <th>Part No</th>
                                    <th>Description</th>
                                    <th>Qty</th>
                                    <th>Current Stock</th>
                                    <th>Status</th>
                                    <th>Issued By</th>
                                    <th>Remark</th>
                                    <th>Date</th>
                                </tr>
                            </thead>

                            <tbody>

                                {historyLoading ? (

                                    <tr>
                                        <td
                                            colSpan="10"
                                            className="text-center"
                                        >
                                            Loading...
                                        </td>
                                    </tr>

                                ) : machineHistory?.length > 0 ? (

                                    machineHistory.map(
                                        (item, index) => (

                                            <tr key={index}>

                                                <td>
                                                    {index + 1}
                                                </td>

                                                <td>
                                                    {item?.mivNo}
                                                </td>

                                                <td>
                                                    {item?.partNo}
                                                </td>

                                                <td>
                                                    {item?.description}
                                                </td>

                                                <td>
                                                    {item?.usedQty}
                                                </td>

                                                <td>
                                                    {item?.currentStock}
                                                </td>

                                                <td>

                                                    {item?.mivStatus === "submit" ? (

                                                        <span className="badge bg-warning text-dark">
                                                            Pending Approval
                                                        </span>

                                                    ) : item?.mivStatus === "close" ? (

                                                        <span className="badge bg-success">
                                                            Completed
                                                        </span>

                                                    ) : (

                                                        <span className="badge bg-secondary">
                                                            {item?.mivStatus || "Open"}
                                                        </span>

                                                    )}

                                                </td>

                                                <td>
                                                    {item?.userName}
                                                </td>

                                                <td
                                                    style={{
                                                        minWidth: "250px",
                                                        whiteSpace: "pre-line"
                                                    }}
                                                >
                                                    {item?.remark || "-"}
                                                </td>

                                                <td>
                                                    {
                                                        item?.createdAt
                                                            ? new Date(
                                                                item.createdAt
                                                            ).toLocaleString(
                                                                "en-GB",
                                                                {
                                                                    hour12: false
                                                                }
                                                            )
                                                            : "-"
                                                    }
                                                </td>

                                            </tr>

                                        )
                                    )

                                ) : (

                                    <tr>
                                        <td
                                            colSpan="10"
                                            className="text-center"
                                        >
                                            No Diesel History Found
                                        </td>
                                    </tr>

                                )}

                            </tbody>
                        </table>


                    </Container>

                </Modal.Body>

                <Modal.Footer className="d-flex justify-content-between align-items-center">

                    {/* Left Side */}
                    <div>
                        {editMode && (
                            <Button
                                variant="primary"
                                onClick={handleUpdate}
                            >
                                Save Changes
                            </Button>
                        )}
                    </div>

                    {/* Center */}
                    <div>
                        {editMode && (
                            <Button
                                variant="secondary"
                                onClick={() => {

                                    setStartKM(attendance?.startKM || 0);
                                    setEndKM(attendance?.endKM || 0);
                                    setDieselInReading(attendance?.dieselInReading || 0);
                                    setDieselOutReading(attendance?.dieselOutReading || 0);

                                    setEditMode(false);

                                }}
                            >
                                Cancel
                            </Button>
                        )}
                    </div>

                    {/* Right Side */}
                    <div>
                        <Button
                            variant="danger"
                            className="me-2"
                            onClick={handleReject}
                        >
                            Reject
                        </Button>

                        <Button
                            variant="success"
                            onClick={handleApprove}
                        >
                            Approve
                        </Button>
                    </div>

                </Modal.Footer>

            </Modal>
            <FilePreviewModal
                show={showPreview}
                handleClose={() => setShowPreview(false)}
                file={previewFile}
            />
        </>
    );
};

export default ReviewAttendanceModal;